import axiosInstance from "../axiosInstance";

export const uploadVideo = async (formData) => {
  try {
    const response = await axiosInstance.post("/Video/UploadVideo", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getVideo = async () => {
  try {
    const response = await axiosInstance.get(`/Video/GetVideos`);
    return response.data;
  } catch (error) {
    return error;
  }
};
export const deleteVideo = async (id) => {
  try {
    const response = await axiosInstance.post(`/Video/DeleteVideo?id=${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
